// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3alLb","productName":"Table_productName__2K-Q8"};